import { SearchableInvestorEntry } from "./SearchableInvestorEntry";

export const CartCollection = "carts";

export function buildCartId(nowTime: number): string {
  const now = new Date(nowTime);
  const yyyymmddDate = `${now.getFullYear()}${now.getMonth() + 1}${now.getDate()}`;
  return `cart_${yyyymmddDate}-${Math.random().toString(36).substring(2, 15).toUpperCase()}`;
}

export function mapDocToCart(doc: any): Cart {
  return {
    id: doc.id,
    startedDate: doc.startedDate,
    items: doc.items,
    searchableInvestorEntryIds: doc.searchableInvestorEntryIds,
    pricing: doc.pricing,
    status: doc.status,
    creatorUserId: doc.creatorUserId,
    columnOrder: doc.columnOrder,
    exportFormat: doc.exportFormat,
  };
}

export type CartPricing = {
  totalX100: number;
  tierDescription: string;
  lineItemCount: number;
  stripePaymentLink: string;
};

export type CartItem = {
  id: string;
  searchableInvestorEntry: SearchableInvestorEntry;
};

export type Cart = {
  id: string;
  startedDate: number;
  items: CartItem[];
  searchableInvestorEntryIds: string[];
  pricing?: CartPricing;
  status: "active" | "purchased";
  creatorUserId?: string;
  // Export information:
  columnOrder: string[];
  exportFormat: "csv" | "json" | "xlsx";
};
